import { render } from "./PartA.vue?vue&type=template&id=297ef7fe"
import script from "./PartA.vue?vue&type=script&lang=js"
export * from "./PartA.vue?vue&type=script&lang=js"

import "./PartA.vue?vue&type=style&index=0&id=297ef7fe&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__